<template>
  <div class="header-box clearfix">
    <div class="header-box-min">
      <div class="menu-left">
        <div class="logo">
          <img
            @click="goHomePersonal"
            src="../../assets/img/logo8.png"
            alt=""
            title="返回个人中心"
          />
        </div>
        <div class="n" @click="goHomePersonal" v-if="show">个人中心</div>
        <!-- <div @click="gotoURL" class="gotoJG" style="">进入机构账户中心</div> -->
      </div>

      <ul class="menu-list clearfix" v-if="!Exit && show">
        <li class="tg" @click="toContribution()">
          <span>投稿</span>
        </li>
        <li class="yj" @click="showFeedback()">
          <span>意见</span>
        </li>
        <li class="xx" @click="goMessage()">
          <span v-if="noReadNum" class="noRead">{{ noReadNum }}</span>
          <span>消息</span>
        </li>
        <li class="esc" @click="esc">
          <span>退出</span>
        </li>
      </ul>
      <ul class="menu-list clearfix" v-if="Exit">
        <li class="goLogin">
          <p @click="goLogin">登录</p>
        </li>
      </ul>
    </div>
    <div class="shadow" v-if="ExitSta" @click="ExitSta = false"></div>
    <div class="modalWindow1 exit-login" style="z-index: 9999" v-if="ExitSta">
      <div class="modalWindow__top">
        <p class="modalWindow--txt1">
          确认要退出吗？<span
            class="modalWindow--close1"
            @click="ExitSta = false"
          ></span>
        </p>
      </div>
      <div class="modalWindow__btn">
        <button class="btn ui-widget-header" @click="ExitSta = false">
          取消
        </button>
        <button class="btn1 btn ui-widget-header" @click="goExit">确认</button>
      </div>
    </div>
    <!-- 意见反馈弹窗 -->
    <el-dialog
      class="dialog"
      :visible.sync="isFeedback"
      width="30%"
      :before-close="handleClose"
    >
      <feedback @close="close" v-if="isFeedback"></feedback>
    </el-dialog>
    <div class="shadow" v-if="isFeed" @click="isFeed = false"></div>
    <LayerOpen
      v-if="isFeed"
      :title="'提示'"
      @submitBtn="isFeed = false"
      @close="isFeed = false"
    >
      <template v-slot:header>
        <div class="success-text">提交成功</div>
      </template>
    </LayerOpen>
  </div>
</template>

<script>
import { Get, Post } from "@/api/axios";
import LayerOpen from "../layerOpen/index";
import feedback from "@/components/feedback/index";
export default {
  components: { feedback, LayerOpen },
  data() {
    return {
      ExitSta: false,
      Exit: false,
      isFeedback: false,
      isFeed: false,
      index: 0,
      noReadNum: 0,
      noReadNumLoading: false,
      show: true
    };
  },
  created() {
    if (localStorage.getItem("loginProviderId")) {
      return false;
    }
    this.$bus.$on("rechNUm", () => {
      this.init();
    });
    // this.getNums();
  },
  computed: {
    memberId() {
      return this.$store.state.memberId;
    }
  },
  watch: {
    memberId: {
      handler () {
        this.init();
      },
      deep: true,
      immediate: true
    }
    // memberId(n, o) {
    //   console.log(n, "监听nnnnn");
    // }
  },
  mounted() {
    this.$bus.$on('logout', data => {
      console.log(data, '退出登录')
      if (data === 1) {
        this.logoutFn()
      } else if (data === 2) {
        this.goExit()
      }
    });
    this.$bus.$on("upDataIsShow", () => {
      console.log('事件总线触发');
      if (location.href.indexOf("signOutSuccess") !== -1) {
        this.show = false;
      }
    });
     console.log(this.show, "this.show1234");
  },
  methods: {
    getCookie(cname) {
      console.log("获取cookie中的 uuid");
      var name = cname + "=";
      var ca = document.cookie.split(";");
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i].trim();
        if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
      }
      return "";
    },
    logoutFn () {
      let url = "/member/cas/logout?uuid=" + this.getCookie('uuid');
      this.cleart();
      Get(url, {
        redirectUrl:
          window.location.protocol + "//" + window.location.host + "/personal"
      }).then(res => {
        localStorage.removeItem("addLoginNameId");
        localStorage.removeItem("time");
        localStorage.removeItem("memberId");
        localStorage.removeItem("addLoginName");
        localStorage.removeItem("loginName");
        localStorage.removeItem("gy");
        localStorage.removeItem("uuid");
        localStorage.removeItem("TabUrl");
        sessionStorage.clear();
        localStorage.setItem("isLogout", "true");
      })
    },
    gotoURL() {
      window.location = localStorage.getItem("journalDbUrl");
    },
    // getNums() {
    //   if (!localStorage.getItem("memberId")) {
    //     this.getNums();
    //   } else {
    //     this.init();
    //   }
    // },
    init() {
      let params = {
        userId: localStorage.getItem("memberId"),
        type: 1,
        userSystem: "C_USER_SYSTEM"
      };
      let params2 = {
        userId: localStorage.getItem("memberId"),
        type: 2,
        userSystem: "C_USER_SYSTEM"
      };
      let url = `/member/spc/${this.$version1}/getDialogReplyNoReadNum`;
      Get(url, params).then(res => {
        let data1 = res.data;
        // this.noReadNum = Number(data);
        Get(url, params2).then(res => {
          let data = res.data;
          this.noReadNum = (Number(data1) + Number(data));
          // setTimeout(() => {
          //   this.noReadNumLoading = true
          // }, 1000)
        });
      });
    },
    handleClose() {
      this.isFeedback = false;
    },
    cleart() {
      var keys = document.cookie.match(/[^ =;]+(?=\=)/g);
      if (keys) {
        for (var i = keys.length; i--; )
          document.cookie = keys[i] + "=0;expires=" + new Date(0).toUTCString();
      }
    },
    goMessage() {
      this.$router.push({
        path: "/personal",
        query: { nowNav: "messagePage", nowNavName: "消息", index: this.index }
      });
      $("body,html").animate({ scrollTop: 0 }, 300);
      this.index++;
      this.$route.query.id = this.index;
      this.$bus.$emit("getNavName", "系统反馈");
      // location.reload()
    },
    goHomePersonal() {
      if (this.show) {
        this.$router.push({
          path: "/personal",
          query: { nowNav: "home", type: "click" }
        });
        $("body,html").animate({ scrollTop: 0 }, 300);
        this.$bus.$emit("getNavName", " ");
      }
    },
    goLogin() {
      this.ExitSta = false;
      this.Exit = false;

      // this.$router.push("/login");
    },
    goExit() {
      this.ExitSta = false;
      this.Exit = true;
      localStorage.setItem("ExitSta", true);
      let url = "/member/cas/logout?uuid=" + localStorage.getItem("uuid");
      this.cleart();
      Get(url, {
        redirectUrl:
          window.location.protocol + "//" + window.location.host + "/personal"
      }).then(res => {
        console.log(res, "res");
        if (typeof res == "object") {
          this.$message.error("应用访问令牌已过期,请重新认证！");
          // window.reload();
        } else {
          localStorage.removeItem("addLoginNameId");
          localStorage.removeItem("time");
          localStorage.removeItem("memberId");
          localStorage.removeItem("addLoginName");
          localStorage.removeItem("loginName");
          localStorage.removeItem("gy");
          localStorage.removeItem("uuid");
          localStorage.removeItem("TabUrl");
          sessionStorage.clear();
          localStorage.setItem("isLogout", "true");
          location.href = res;
        }
      });
    },
    esc() {
      this.ExitSta = true;
    },
    goHome() {
      if (this.$route.path == "/Commodity") {
        this.$router.push({ path: "/personal?nowNav=cart" });
      } else {
        this.$router.push({ path: "/personal?nowNav=basicInfo" });
      }
    },
    showFeedback() {
      this.isFeedback = true;
    },
    // 投稿跳转
    toContribution() {
      window.open("https://medpress.yiigle.com/", "_black");
    },
    close(v, n) {
      if (v && v == "up") {
        this.isFeed = true;
      }
      this.isFeedback = false;
    }
  }
};
</script>
<style lang="scss" scoped>
.dialog /deep/ .el-dialog__header {
  display: none;
  padding: 0 !important;
}

.dialog /deep/ .el-dialog__body {
  // display: none;
  padding: 0;
}

.header-box {
  min-width: 1200px;
  background: #016072;
  padding: 15px 0px 15px 40px;

  .header-box-min {
    min-width: 1145px;
  }

  .menu-left {
    float: left;
    // width: 486px;
    margin-left: -6px;

    .logo {
      display: inline-block;
      vertical-align: middle;

      img {
        cursor: pointer;
        max-height: 66px;
      }
    }

    .n {
      display: inline-block;
      font-size: 18px;
      color: #fff;
      vertical-align: middle;
      position: relative;
      padding-left: 38px;
      margin-left: 45px;
      border-left: 0.5px solid #014e5f;
      height: 50px;
      line-height: 50px;
      cursor: pointer;
    }
  }

  .menu-list {
    height: 50px;
    line-height: 50px;
    float: right;
    margin-top: 5px;

    .tg {
      background: url("../../assets/images/ContributionIcon.png");
      background-repeat: no-repeat;
      background-position: left 33px center;
      border-left: 1px solid #014e5f;
    }
    .tg:hover {
      background: url("../../assets/images/ContributionIconHover.png");
      background-repeat: no-repeat;
      background-position: left 33px center;
      color: #b8a55e;
    }
    .yj {
      background: url("../.././assets/img/user__icon1.png");
      background-repeat: no-repeat;
      background-position: left 33px center;
      border-left: 1px solid #014e5f;
    }

    .yj:hover {
      background: url("../.././assets/img/user__icon4.png");
      color: #65cce0;
      background-repeat: no-repeat;
      background-position: left 33px center;
    }

    .xx {
      background: url("../.././assets/img/user__icon2.png");
      background-repeat: no-repeat;
      background-position: left 33px center;
      border-left: 1px solid #014e5f;
      position: relative;

      .noRead {
        position: absolute;
        top: -2px;
        right: 58px;
        background: #eb3458;
        color: #fff;
        display: inline;
        padding: 0px 7px;
        line-height: 20px;
        border-radius: 20px;
        font-size: 12px;
      }
    }

    .xx:hover {
      background: url("../.././assets/img/user__icon5.png");
      color: #65cce0;
      background-repeat: no-repeat;
      background-position: left 33px center;
    }

    .esc {
      background: url("../.././assets/img/user__icon3.png");
      background-repeat: no-repeat;
      background-position: left 33px center;
      border-left: 0.5px solid #014e5f;
    }

    .esc:hover {
      background: url("../.././assets/img/user__icon6.png");
      color: #65cce0;
      background-repeat: no-repeat;
      background-position: left 33px center;
    }

    .goLogin {
      width: 100px;
      height: 38px;
      line-height: 38px;
      font-size: 18px;
      border-radius: 30px;
      background: #5dcce2;
      color: white;
      text-align: center;
      margin-right: 20px;
    }

    .goLogin:hover {
      background: #5cc5da;
    }

    li {
      width: 138px;
      // border-left: 1px solid rgba(0, 0, 0, 0.3);
      color: #52b8cc;
      float: left;
      text-align: center;
      font-size: 16px;
      cursor: pointer;
      user-select: none;

      span {
        padding-left: 54px;
      }

      // .icon {
      //   display: inline-block;
      //   width: 24px;
      //   height: 24px;
      //   vertical-align: middle;
      //   position: relative;
      //   z-index: 2;
      //   margin-right: 10px;
      // }
      .icon.opinion {
        background: url("../../../static/img/opinion.png") no-repeat center;
        background-size: 20px;
      }

      .icon.message {
        background: url("../../../static/img/message.png") no-repeat center;
        background-size: 20px;
      }

      .icon.out {
        background: url("../../../static/img/signout.png") no-repeat center;
        background-size: 20px;
      }
    }
  }
}

.success-text {
  text-align: center;
  font-size: 16px;
}
.gotoJG {
  display: inline-block;
  color: #52b8cc;
  cursor: pointer;
  position: relative;
  top: 4px;
  left: 10px;
}
.gotoJG:hover {
  color: #65cce0;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/header/index.vue